import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {
    FIELD_LIST_INPUT_PARTNERS_AND_SPONSORS_AVOSKIN_TRAIL_RUN,
    FIELD_NAME_INPUT_PARTNERS_AND_SPONSORS_AVOSKIN_TRAIL_RUN
} from "../../utils/input-field-list-static-page";
import {
    setAvoskinTrailRunErrorMessage,
    setAvoskinTrailRunMainBannerDetail, setAvoskinTrailRunPartnersAndSponsorsDetail
} from "../../reducers/avoksin-trail-run.reducer";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import React, {useEffect} from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const PartnersAndSponsors = () => {
    const dispatch = useDispatch()
    const {partnersAndSponsorsDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getPartnersAndSponsors} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_PARTNERS_AND_SPONSORS)
    const {fetching: updatePartnersAndSponsors, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_PARTNERS_AND_SPONSORS)
    let fieldListInput = FIELD_LIST_INPUT_PARTNERS_AND_SPONSORS_AVOSKIN_TRAIL_RUN
    let showPartnersAndSponsors = {
        label: 'Partners & Sponsors',
        key: 'show_partners_and_sponsors',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunPartnersAndSponsorsDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updatePartnersAndSponsors(partnersAndSponsorsDetail).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Partners & Sponsorship Updated'))
            dispatch(setAvoskinTrailRunPartnersAndSponsorsDetail(response?.data))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_INPUT_PARTNERS_AND_SPONSORS_AVOSKIN_TRAIL_RUN)))
        })
    }

    useEffect(() => {
        getPartnersAndSponsors().then(response => {
            dispatch(setAvoskinTrailRunPartnersAndSponsorsDetail(response?.data))
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={partnersAndSponsorsDetail}
            switchToggleField={showPartnersAndSponsors}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoskinTrailRunErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default PartnersAndSponsors
